import { For, Show } from "solid-js"
import { delayTone, formatClock, formatDelay, formatProgress } from "../lib/format"
import { mapController } from "../map/controller"
import { app } from "../store/app"
import { RouteBadge } from "./RouteBadge"

export function VehicleView() {
  const vehicle = () => app.selectedVehicle()
  const found = () => {
    const v = vehicle()
    return v ? app.findRoute(v.routeId) : null
  }

  return (
    <Show when={vehicle()} fallback={<div class="panel-body"><div class="empty">vehicle went offline</div></div>}>
      {(v) => (
        <div class="panel-body">
          <div class="hero">
            <Show when={found()}>{(item) => <RouteBadge route={item().route} />}</Show>
            <div>
              <div class="hero-title">{v().headsign || v().routeName}</div>
              <div class="muted">{v().id}</div>
            </div>
          </div>

          <div class="stat-grid">
            <div class="stat">
              <div class="label">status</div>
              <div class={`value ${delayTone(v().delay)}`}>{formatDelay(v().delay)}</div>
            </div>
            <div class="stat">
              <div class="label">progress</div>
              <div class="value">{formatProgress(v().progress)}</div>
            </div>
            <div class="stat">
              <div class="label">next stop</div>
              <div class="value">{v().nextStopName || "—"}</div>
            </div>
            <div class="stat">
              <div class="label">closest</div>
              <div class="value">{v().closestStopName || "—"}</div>
            </div>
          </div>

          <Show when={v().progress != null}>
            <div class="progress big">
              <div
                class="progress-fill"
                style={{
                  width: `${Math.round((v().progress || 0) * 100)}%`,
                  background: `#${app.routeColor(v().routeId, v().routeColor)}`,
                }}
              />
            </div>
          </Show>

          <div class="action-row">
            <button
              class="btn primary"
              onClick={() => {
                app.setFollowVehicle(true)
                mapController.focusVehicle(v())
              }}
            >
              follow on map
            </button>
            <button class="btn" onClick={() => app.openRoute(v().routeId)}>
              view route
            </button>
          </div>

          <h3 class="section-title">Stops on this trip</h3>
          <Show when={app.loadingDetail() && !app.tripStops().length}>
            <div class="empty">loading trip…</div>
          </Show>
          <Show when={!app.loadingDetail() && !app.tripStops().length}>
            <div class="empty">no stop list available</div>
          </Show>
          <Show when={app.tripStops().length}>
            <div class="action-row">
              <button
                class="btn"
                onClick={() =>
                  mapController.showStops(app.tripStops(), {
                    color: app.routeColor(v().routeId, v().routeColor),
                  })
                }
              >
                show stops on map
              </button>
              <button
                class="btn"
                onClick={() =>
                  mapController.showStops(app.tripStops(), {
                    color: app.routeColor(v().routeId, v().routeColor),
                    fit: true,
                  })
                }
              >
                fit stops
              </button>
            </div>
            <ol class="trip-stops">
              <For each={app.tripStops()}>
                {(stop) => (
                  <li
                    class={`clickable-stop ${stop.passed ? "passed" : ""} ${stop.next ? "next" : ""}`}
                    onClick={() => {
                      mapController.showStops(app.tripStops(), {
                        color: app.routeColor(v().routeId, v().routeColor),
                      })
                      mapController.focusStop(stop.id)
                    }}
                  >
                    <span class="stop-name">{stop.name}</span>
                    <span class="muted">{formatClock(stop.departure || stop.arrival)}</span>
                  </li>
                )}
              </For>
            </ol>
          </Show>
        </div>
      )}
    </Show>
  )
}
